
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Source Onboarding', value: 'source_onboarding_name'},
  { text: 'Inputer ID - Name', value: 'request_by'},
  { text: 'Nama Merchant', value: 'merchant_name'},
  { text: 'Reference No', value: 'reference_number'},
  { text: 'MID', value: 'mid'},
  { text: 'Jenis Pengajuan', value: 'task_type'},
  { text: 'Jenis QR', value: 'qr_type'},
  { text: 'Branch Code BC/KO', value: 'bcko'},
  { text: 'Merchant Category Segment', value: 'cmer'},
  { text: 'Tanggal Pengajuan', value: 'created_at'},
  { text: 'Last Update', value: 'updated_at'},
  { text: 'Status', value: 'status',  align: 'center', textAlign: 'text-center'},
  { text: 'Action', value: 'action', width: '10' }
]);

export const dataSourceOnboardingList = [
  { value: '0', text: 'N/A' },
  { value: '1', text: 'BNI MOM' },
  { value: '2', text: 'BNI Merchant' },
  { value: '3', text: 'BNI Move' },
];

export const dataListTaskType = [
  { value: '0', text: 'Add New Merchant' },
  { value: '1', text: 'Add New Aggregator' },
  { value: '2', text: 'Add New Sub Merchant' },
  { value: '3', text: 'Add New Outlet' },
  { value: '4', text: 'Edit Merchant Data PTEN' },
  { value: '5', text: 'Edit Merchant Data Non PTEN' },
  { value: '6', text: 'Edit Aggregator' },
  { value: '7', text: 'Close Merchant' },
  { value: '8', text: 'Blokir Merchant' },
  { value: '9', text: 'Unblokir Merchant' },
  // { value: "10", text: "Blokir Aggregator" },
  // { value: "11", text: "Unblokir Aggregator" },
  // { value: "12", text: "Add Terminal (QR)" },
  // { value: "13", text: "Close Terminal (QR)" },
  // { value: "14", text: "Edit Rekening Setlement" },
  { value: '15', text: 'Edit Settlement Type' },
];

export const dataAllQrType = [
  { value: '1', text: 'QR Sticker' },
  { value: '3', text: 'QR EDC' },
  { value: '2', text: 'QR API' },
  { value: '4', text: 'QR Sticker & API' },
  { value: '5', text: 'QR Sticker & API & EDC ' },
  { value: '6', text: 'QR Sticker & EDC' },
  { value: '7', text: 'QR API & EDC' },
  { value: '8', text: 'CPTS' },
];

export const dataListTrackingPengajuanStatus = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Need Revision' },
  { value: '3', text: 'Revised' },
  { value: '4', text: 'On Progress Approver 1' },
  { value: '5', text: 'Rejected By Approver 1' },
  { value: '6', text: 'Approved by Approver 1' },
  { value: '7', text: 'On Progress Approver 2' },
  { value: '8', text: 'Rejected by Approver 2' },
  { value: '9', text: 'Approved by Approver 2' },
  { value: '71', text: 'Waiting To PTEN' },
  { value: '10', text: 'Send To PTEN' },
  // { value: "11", text: "Downloaded PTEN" },
  { value: '12', text: 'Reject by PTEN' },
  { value: '72', text: 'Waiting To Cardlink' },
  { value: '50', text: 'Send To Cardlink' },
  { value: '61', text: 'Waiting to Approval Activation' },
  { value: '62', text: 'Approve force active' },
  { value: '51', text: 'Waiting to Active' },
  { value: '13', text: 'Active' },
  { value: '14', text: 'Failed' },
];

export const search = {
  source_onboarding: '',
  request_by: '',
  merchant_name: '',
  mid: '',
  task_type: '',
  qr_type: '',
  bcko: '',
  cmer: '',
  status: '',
  reference_number: '',
  created_at: [],
  updated_at: null,
};

